var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReset(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 8,
    viewBox: "0 0 8 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.82488 1.175C6.09988 0.45 5.10488 0 3.99988 0C1.78988 0 0.00488281 1.79 0.00488281 4C0.00488281 6.21 1.78988 8 3.99988 8C5.86488 8 7.41988 6.725 7.86488 5H6.82488C6.41488 6.165 5.30488 7 3.99988 7C2.34488 7 0.999883 5.655 0.999883 4C0.999883 2.345 2.34488 1 3.99988 1C4.82988 1 5.56988 1.345 6.10988 1.89L4.49988 3.5H7.99988V0L6.82488 1.175Z",
    fill: "#828282"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReset);
export default __webpack_public_path__ + "static/media/reset.70332384861f2833c029beca5a25a504.svg";
export { ForwardRef as ReactComponent };